import { memo } from 'react';

import PersonBasicInfoHeader from '@/components/PersonBasicInfoHeader';

import IdentifierRow from './components/IdentifierRow';
import PersonContactCard from './components/PersonContactCard';
import PersonEpisodeOfCare from './components/PersonEpisodeOfCare';
import type { Props } from './types';

const PersonBasicInfo = ({ person, withHeader = true }: Props) => {
  const { medical_record_number } = person;

  return (
    <div className="flex flex-col gap-4">
      {withHeader && <PersonBasicInfoHeader person={person} />}
      <PersonEpisodeOfCare person={person} />
      <PersonContactCard person={person} />
      <dl className="grid grid-cols-[auto_minmax(0,1fr)] items-center gap-x-6 gap-y-3">
        <IdentifierRow label="Person ID" value={person.id} />
        {medical_record_number && <IdentifierRow label="MRN" value={medical_record_number} />}
      </dl>
    </div>
  );
};

export default memo(PersonBasicInfo);
